
import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare, Eye } from 'lucide-react';
import { useLanguage } from '@/context/language-context';

interface ProfileCardFooterProps {
  handleViewProfile: () => void;
  handleSendMessage: (e: React.MouseEvent) => void;
  canMessage: boolean;
}

const ProfileCardFooter = ({ 
  handleViewProfile, 
  handleSendMessage, 
  canMessage 
}: ProfileCardFooterProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="grid grid-cols-2 gap-2 mt-4">
      <Button 
        variant="outline" 
        size="sm" 
        className="w-full"
        onClick={handleViewProfile}
      >
        <Eye size={16} className="mr-1" />
        {t('View Profile')}
      </Button>
      <Button 
        variant={canMessage ? "default" : "outline"}
        size="sm" 
        className="w-full"
        onClick={handleSendMessage}
        disabled={!canMessage}
      >
        <MessageSquare size={16} className="mr-1" />
        {t('Message')}
      </Button>
    </div>
  );
};

export default ProfileCardFooter;
